module.exports = __webpack_public_path__ + "img/02.444623a7.gif";